export default __webpack_public_path__ + "static/media/ARSW.bb5e926b.jpg";